<div class="node-wrap">
    <div class="node-wrap-box">
        <div class="node-wrap-body" (click)="onClickEvent($event)">
            <div class="node-wrap-content-broder" [ngClass]="{'background-color-error': isNodeNotValid()}">
            </div>
            <div class="node-wrap-content-input">
                <input *ngIf="node.showInput" #valueInput [(ngModel)]="node.name" (blur)="onBlur($event)"
                    (keydown)="onkeydown($event)" [class.input-error]="node.name.trim().length > 64" />
                <div *ngIf="!node.showInput" class="span-name" (dblclick)="onDblclick()">
                    <span [title]="node.name">{{node.name}}</span>
                </div>
            </div>
            <div class="node-wrap-content-icon" (click)="onClickMeatball($event)">
                <smart-icon name="meatball"></smart-icon>
            </div>
            <div class="stage" *ngIf="node.stage&&node.stageColor">
                <span [style.background]="node.stageColor.backColor" [style.color]="node.stageColor.fontColor"
                    [title]="node.stage">{{node.stage}}</span>
            </div>
        </div>
    </div>
    <ng-container *ngIf="node.automationConfigs">
        <tam-diagram-automation-render [automationConfigs]="node.automationConfigs" [targetId]="node.id"></tam-diagram-automation-render>
    </ng-container>
    <div class="add-node-btn-box">
        <div class="add-node-btn">
            <button class="btn" type="button" #addButton (click)="onAddChildClicked($event)">
                <smart-icon name="add-square" class="add-icon"></smart-icon>
            </button>
        </div>
    </div>
    <ng-container *ngIf="node.hasChildren()">
        <tam-diagram-node *ngFor="let child of node.children" [nodeId]="child" [branchId]="branchId">
        </tam-diagram-node>
    </ng-container>
</div>